module.exports = __webpack_public_path__ + "img/icon1.33d346ed.c6c37e38.png";